declare namespace $ {

	type $mol_view_tree2_to_js_test_ex_klass_tuple__mol_view_tree2_to_js_test_ex_array_constructor_tuple_foo_1 = $mol_type_enforce<
		[ readonly(string)[], ({ 
			'type': string,
		})  ]
		,
		ConstructorParameters< typeof $mol_view_tree2_to_js_test_ex_klass_tuple<string> >
	>
	export class $mol_view_tree2_to_js_test_ex_array_constructor_tuple_foo extends $mol_object {
		text( ): string
		text_blob( next?: $mol_view_tree2_to_js_test_ex_klass_tuple<string> ): $mol_view_tree2_to_js_test_ex_klass_tuple<string>
		blobs( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=array_constructor_tuple.view.tree.d.ts.map